export default __webpack_public_path__ + "static/media/mPants_1.dfe1eae3.bin";